<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import LobbyPage from '$lib/components/pages/LobbyPage.svelte';
  import RoomPage from '$lib/components/pages/RoomPage.svelte';

  // Примитивный «роутер»: состояние on/off. Роуты не нужны — две страницы, без deep-linking.
  let joined = $state<{ userName: string; roomName: string } | null>(null);
</script>

{#if joined}
  <RoomPage
    userName={joined.userName}
    roomName={joined.roomName}
    onLeave={() => (joined = null)}
  />
{:else}
  <LobbyPage onJoin={(payload) => (joined = payload)} />
{/if}
